module.exports = __webpack_public_path__ + "img/Layer_12.5d2ffc26.png";